
<app-navbar customHeader="true" >
  <div class="container-fluid bg-light">
    <div class="row text-center">
      <div class="col-12">
        <div class="text-center mt-5">
          <h2 class="title-page text-center">Recuperação de Senha</h2>
        </div>
        <div class="row d-flex align-center justify-content-center mt-3 p-5">
          <div class="col-8">
        <div class="text-box p-5">
          <div class="descricao mt-2">
            Informe abaixo o CPF que utilizou no seu cadastro. Enviaremos um email com um código de confirmação de reinicialização de sua senha.
          </div>
          <form class="text-left" [formGroup]="formForgotPassword">
            <div class="form-row mt-3 d-flex align-center justify-content-center">
              <div class="col-7 mt-5">
                <div class="form-outline">
                  <label mdbLabel class="form-label" for="form1">Documento Identificador <i
                    class="fas fa-info-circle"
                    mdbTooltip="Remova a pontuação antes de enviar."
                    placement="top"></i>
                </label>
                  <input
                    data-testid="cpf-recuperar-senha"
                    mask="000.000.000-00"
                    formControlName="document"
                    placeholder="Digite seu CPF cadastrado"
                    type="text"
                    id="form1"
                    class="form-control form-icon-trailing"
                  />
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 mt-5 d-flex align-center justify-content-center">
                <button data-testid="botao-recuperar-senha" (click)="send()" class="btn custom-btn mt-3">
                  Enviar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
      </div>
    </div>
  </div>
</app-navbar>
